import React from "react";
import { object } from "prop-types";

import "./iframe.m.css";

const IframeRow = ({ metadata }) => {
  const iframe = (metadata && metadata["iframe_widget_embed_script"]) || "";
  return iframe ? <div styleName="wrapper" dangerouslySetInnerHTML={{ __html: iframe }} /> : null;
};

export default IframeRow;

IframeRow.propTypes = {
  metadata: object
};
